import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import PublicRoute from './PublicRoute';
import PageLoader from '@/components/PageLoader';
import URL from '@/pages/URL';

import HandbookAcknowledgmentHandler from '@/pages/HandbookAcknowledgmentHandler';
import EmployeeHandbook from '@/pages/EmployeeHandbook';

const Login = lazy(() => import(/*webpackChunkName:'LoginPage'*/ '@/pages/Login'));

const NotFound = lazy(() => import(/*webpackChunkName:'NotFoundPage'*/ '@/pages/NotFound'));
const ResetPasswordScreen = lazy(() => import(/*webpackChunkName:'NotFoundPage'*/ '@/pages/ResetPasswordScreen'));
const SeoSnippetEmbed = lazy(() => import(/*webpackChunkName:'SeoSnippetPage'*/ '@/pages/SeoSnippetEmbed'));
const GoogleAdsEmbed = lazy(() => import(/*webpackChunkName:'GoogleAdsPage'*/ '@/pages/GoogleAdsEmbed'));
const SharedTaskView = lazy(() => import(/*webpackChunkName:'SharedTaskView'*/ '@/pages/SharedTaskView'));
const SharedProjectView = lazy(() => import(/*webpackChunkName:'SharedProjectView'*/ '@/pages/SharedProjectView'));

export default function AuthRouter() {
  const location = useLocation();
  return (
    <Suspense fallback={<PageLoader />}>
      <AnimatePresence exitBeforeEnter initial={false}>
        <Switch location={location} key={location.pathname}>
          <Route path="/shared/task/:token" component={SharedTaskView} exact />
          <Route path="/shared/project/:token" component={SharedProjectView} exact />
          <Route path="/handbook/acknowledge/:token" component={HandbookAcknowledgmentHandler} />
          <Route path="/employee-handbook" component={EmployeeHandbook} />
          <Route path="/seo-snippet" component={SeoSnippetEmbed} exact />
          <Route path="/google-ads" component={GoogleAdsEmbed} exact />
          <PublicRoute path="/reset-password/:token" component={ResetPasswordScreen} />
          <PublicRoute path="/" component={Login} exact />
          <Route path="/url/:id" component={URL} />
          <PublicRoute component={Login} path="/login" exact />
          <Route path="*" component={NotFound} />
        </Switch>
      </AnimatePresence>
    </Suspense>
  );
}
